import React, { memo } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import Footer from "../../organisms/Footer";
import { RestaurantSidebar } from "../../organisms/sidebar/RestaurantSidebar";
import RestaurantHeader from "../../organisms/header/RestaurantHeader";
import Layout from "../Layout";

type RestaurantBaseProps = {
    requireAuth?: boolean; // デフォルト: true（保護ルート向け）
    allowNoRestaurantId?: boolean; // デフォルト: false（通常は :restaurantId 必須）
    headerWhenNoRestaurantId?: React.ReactNode; // 任意（"ログイン" 等の共通ヘッダーを出すなら）
    navWhenNoRestaurantId?: React.ReactNode; // 任意（ログインページでサイドバー不要なら null）
};

const RestaurantBase: React.FC<RestaurantBaseProps> = memo(({
                                                                requireAuth = true,
                                                                allowNoRestaurantId = false,
                                                                headerWhenNoRestaurantId = null,
                                                                navWhenNoRestaurantId = null,
                                                            }) => {
    const { restaurantId } = useParams();
    const token = localStorage.getItem('localJWT');

    // 認証ガード（ログインページ等では requireAuth=false にしてスキップ）
    if (requireAuth && !token) return <Navigate replace to="/restaurant-login" />;

    // restaurantId が無い場合でも描画を許可するか
    if (!restaurantId) {
        if (!allowNoRestaurantId) return null;
        return (
            <Layout
                header={headerWhenNoRestaurantId}
                nav={navWhenNoRestaurantId}
                main={<Outlet />}
                footer={<Footer />}
            />
        );
    }

    // 通常（:restaurantId がある場合）
    return (
        <Layout
            header={<RestaurantHeader restaurantId={restaurantId} />}
            nav={<RestaurantSidebar restaurantId={restaurantId} />}
            main={<Outlet />}
            footer={<Footer />}
        />
    );
});

export default RestaurantBase;